<template>
    <div :class="'wrapper '+section">
        <!-- header -->
        <div class="header shadow">
            <b-row no-gutters>
                <b-col cols="auto">
                    <b-button @click="goBack" variant="link" class="text-dark" v-if="back">
                        <i class="material-icons">chevron_left</i>
                    </b-button>
                    <b-button variant="link" to="/profile/information" v-else
                        :class="user.status === 203 ? 'text-success' : (user.status === 202 ? 'text-warning' : 'text-danger')">
                        <i class="material-icons">verified_user</i>
                    </b-button>
                </b-col>
                <b-col class="text-center">
                    <img :src="logo" alt="logo-moregiros" class="header-logo py-0">
                </b-col>
                <b-col cols="auto">
                    <b-button variant="link" to="/notifications" class="text-dark position-relative">
                        <i class="material-icons">notifications_none</i>
                        <span class="counts">{{ count < 10 ? count : '+9' }}</span>
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <!-- header ends -->

        <transition name="fade" mode="out-in">
            <router-view
                :user="user"
                @notifications="getIni"
                @success="update"
                @loader="hideLoader"
                @section="getSection"
            ></router-view>
        </transition>

        <!-- footer-->
        <footer class="footer">
            <b-row no-gutters>
                <b-col cols="auto" class="mx-auto">
                    <b-row no-gutters align-h="center">
                        <template v-for="item in navs">
                            <b-col cols="auto">
                                <b-button variant="link-default" :to="item.link">
                                    <i :class="'material-icons mdi mdi-'+item.icon"></i>
                                    <p>{{ item.name }}</p>
                                </b-button>
                            </b-col>
                        </template>
                    </b-row>
                </b-col>
            </b-row>
        </footer>
        <!-- footer ends-->
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import axios from 'axios';

export default {
    name: "CustomerComponent",
    data: () => ({
        logo: '/img/logo_header.png',
        section: '',
        back: false,
        count: 0,
        user: {
            id: null,
            name: null,
            lname: null,
            phone: null,
            email: null,
            country: null,
            role: 'Customer',
            status: null
        },
        navs: [
            {
                link: '/calculator',
                icon: 'swap-horizontal-circle',
                name: 'Cotizador'
            },{
                link: '/request',
                icon: 'send-circle',
                name: 'Enviar'
            },{
                link: '/home',
                icon: 'home-circle',
                name: 'Inicio'
            },{
                link: '/history',
                icon: 'sync-circle',
                name: 'Historial'
            },{
                link: '/profile',
                icon: 'account-circle',
                name: 'Perfil'
            }
        ]
    }),
    mounted() {
        this.user = Object.assign(this.user, this.auth);
        this.timeout = setTimeout(this.getIni, 300000);
        this.getIni();
        this.update();
    },
    computed: mapGetters({
        auth: 'user',
    }),
    watch: {
        'user.role'() {
            if (this.user.role !== 'Customer') {
                if(this.user.role === 'Supervisor' || this.user.role === 'Partner' || this.user.role === 'Cashier') {
                    this.$router.push({ name: "PartnerHome" });
                } else {
                    this.$router.push({ name: "AdminHome" });
                }
            } else {
                this.$emit('loader');
            }
        },
        'user.status'() {
            if (this.user.status === 202) {
                this.timeout = setTimeout(this.update, 15000);
            } else {
                clearTimeout(this.timeout);
            }
        }
    },
    methods: {
        getIni() {
            axios.get('/api/customer/notifications/count').then((res) => {
                this.count = res.data.notifications;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        hideLoader() {
            if (this.user.role === 'Customer') {
                this.$emit('loader');
            }
        },
        getSection(val) {
            this.section = val;
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        },
        update() {
            axios.get('/api/profile').then((res) => {
                this.user = res.data.user;
                this.$store.dispatch('setUser', res.data);
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        async logout() {
            await this.$store.dispatch("logout");
            this.$root.$bvToast.toast('Has cerrado sesión correctamente.', {
                title: 'Felicitaciones',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            await this.$router.push({ name: "Login" });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>
